import { useLanguage } from '../context/LanguageContext';

export const PrivacyPage = () => {
  const { isRTL } = useLanguage();

  return (
    <div className="min-h-screen pt-16" data-testid="privacy-page">
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className={`text-4xl font-bold text-slate-900 font-heading mb-8 ${isRTL ? 'text-right' : 'text-left'}`}>
            Privacy Policy
          </h1>
          
          <div className={`prose prose-slate max-w-none ${isRTL ? 'text-right' : 'text-left'}`}>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">1. Data Protection Overview</h2>
            <p className="text-slate-600 mb-4">
              The following information will provide you with an easy to navigate overview of what will 
              happen with your personal data when you visit this website. Personal data comprises all data 
              that can be used to personally identify you.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">2. Data Collection on Our Website</h2>
            <p className="text-slate-600 mb-4">
              <strong>Who is responsible for data collection?</strong><br />
              The data collected on this website is processed by the website operator: GermanExpo Solutions.
            </p>
            <p className="text-slate-600 mb-4">
              <strong>How do we collect your data?</strong><br />
              Your data is collected when you provide it to us, such as when you enter data into our contact form.
              Other data is automatically recorded by our IT systems when you visit the website.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">3. What Do We Use Your Data For?</h2>
            <p className="text-slate-600 mb-4">
              Part of the information is generated to guarantee the error-free provision of the website. 
              Other data may be used to analyze your user patterns. When you contact us via the contact form, 
              we use your data to respond to your inquiry and process your request.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">4. Your Rights</h2>
            <p className="text-slate-600 mb-4">
              You have the right to receive information about the source, recipients, and purposes of your 
              archived personal data at any time without having to pay a fee for such disclosures. You also 
              have the right to demand that your data is rectified or eradicated.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">5. Contact Form</h2>
            <p className="text-slate-600 mb-4">
              If you submit inquiries to us via our contact form, the information provided in the contact 
              form as well as any contact information provided therein will be stored by us in order to handle 
              your inquiry and in the event that we have further questions.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">6. Data Security</h2>
            <p className="text-slate-600">
              This website uses SSL or TLS encryption for security reasons and to protect the transmission 
              of confidential content. You can recognize an encrypted connection by checking whether the 
              address line of the browser switches from "http://" to "https://".
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
